import { render, staticRenderFns } from "./OrticFilterText.vue?vue&type=template&id=c6319468&"
import script from "./OrticFilterText.vue?vue&type=script&lang=js&"
export * from "./OrticFilterText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports